module.exports = __webpack_public_path__ + "img/1890_Stainzerhof.9d758da1.jpg";